import { Link, useParams } from "react-router-dom"
import Layout from "../Frames/Layout"
import API from "../../services/API"
import Loader from "../Tools/Loader"
import { Accordion, AccordionDetails, AccordionSummary, Alert, Stack, TextField, Typography } from "@mui/material"
import { useState } from "react"
import { useEffect } from "react"
import { useContext } from "react"
import ToastContext from "../../services/Context/ToastContext"
import { LoadingButton } from "@mui/lab"
import { ExpandMore } from "@mui/icons-material"
import Top from "./Common/Top"

export default function CourseOverview(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const [data, setData] = useState({})

    const [status, setStatus] = useState('loading')
    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        if(id !== 'new'){

            API.get(`/design/courses/${id}`)
                .then(r => {
                    setData(r.data)
                    setStatus('ready')
                })
                .catch(e => setStatus('error'))
            
        }else{
            setStatus('new')
        }

    }, [id])


    const handleSubmit = e => {
        e.preventDefault();

        setStatus('submit')

        save().then(handleSuccess)
            .catch(handleError)
            .finally(() => setStatus('ready'))
    }

    const save = () => API.put(`/design/courses/${id}`, data);

    const handleSuccess = r => {
        setToast({
            severity: 'success', 
            message: 'Vos modifications ont été enregistrées avec succès', 
            duration: 3000
        })
    }

    const handleError = e => {
        setToast({
            severity: 'error', 
            message: e.response?.data?.error || "Une erreur s'est produite. Vérifiez le formulaire.", 
            duration: 3000
        })
    }

    const handleGoalChange = (e,i) => {
        let goals = [...data.goals];
        goals[i] = e.target.value;
        setData({...data, goals});
    }


    return <Layout menu='design' tab='overview'>

        {statusIn(['ready','submit']) && 

            <form onSubmit={handleSubmit}>

                <Stack spacing={3} sx={{maxWidth: 600, margin: 'auto'}}>

                    <Top title="Objectifs de la formation" />

                    <Accordion variant='outlined' defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography>Liste des objectifs</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack spacing={3}>
                                {[0,1,2,3,4,5,6,7,8,9].map(i => 
                                    <TextField
                                        key={i} 
                                        label={`Objectif ${i+1}`}
                                        value={data.goals[i] || ''}
                                        onChange={e => handleGoalChange(e,i)}
                                        size='small'
                                        inputProps={{minLength: 3, maxLength: 200}}
                                    />    
                                )}
                            </Stack>
                        </AccordionDetails>
                    </Accordion>

                    <LoadingButton
                        type='submit'
                        variant='contained'
                        loading={statusIs('submit')}
                    >
                        Enregistrer
                    </LoadingButton>

                </Stack>

            </form>
        }

        {statusIs('loading') && 
            <Loader />
        }

        {statusIs('new') && 
            <Alert severity="warning">
                Veuillez finaliser la <Link to={`/design/${id}`}><u>création de la formation</u> avant d'éditer la page de vente</Link>.
            </Alert>
        }

        {statusIs('error') && 
            <Alert severity='error'>Une erreur s'est produite.</Alert>
        }

    </Layout>
}